<template>
    <div>
        <UButton
            :data-cy="SubAccountCy.ButtonCreate"
            @click="showCreateNew"
        >
            Ny {{ isCustomer ? 'kunde' : 'leverandør' }}
        </UButton>
        <targeting-router-link class="text-primary font-semibold underline underline-offset-4 hover:no-underline text-sm ml-2 w-fit" :to="SACC_IMPORT">
            {{ isCustomer ? 'Importer kunder' : 'Importer leverandører' }}
        </targeting-router-link>

        <div
            v-if="visible && subAccount"
            class="absolute flex justify-center items-center z-10 w-full top-0 h-full"
            :class="{ 'bg-black/60 z-1 w-full h-full absolute top-0 left-0 ': visible, ' pointer-events-none': !visible }"
        >
            <UCard
                :ui="{
                    root: 'w-[50rem]'
                }"
            >
                <template #default>
                    <sub-account-editor
                        :sub-account="subAccount"
                        :fulfillment="fulfillment"
                        @created="refreshAndHide"
                        @updated="refreshAndHide"
                        @deleted="refreshAndHide"
                        @hide-editor="hide"
                    />
                </template>
            </UCard>
        </div>
    </div>
</template>

<script setup lang="ts">
import {inject, onUnmounted, Ref, ref} from 'vue'
import {CUSTOMER, NewSubAccount, SubAccount} from '@/subaccount/types/SubAccount'
import {fetchCustomers, fetchSuppliers} from '@/subaccount/subAccount.service'
import {SET_SUB_ACCOUNT_EDITOR_CONTENT, SetSubAccountEditorContent} from '@/subaccount/types/SetSubAccountEditorContent'
import {useEmitter} from '@/services/infrastructure/emitter'
import {SACC_IMPORT} from '@/subaccount'
import { TargetingRouterLink } from '@tritt/multipanel'
import {defaultNewCustomer, defaultNewSupplier} from '@/subaccount/SubAccount.builder'
import SubAccountEditor from '@/subaccount/SubAccountEditor.vue'
import {SubAccountCy} from '@/subaccount/components/SubAccountCy'
import {Fulfillment} from '@/assignments/Assignment.type'

const {onEvent, cleanUp} = useEmitter()
const visible = ref(false)
const subAccount = ref<SubAccount | NewSubAccount>()
const fulfillment = ref<Fulfillment>()

const currentPanelId: Ref<number> | undefined = inject('panelId')
const emit = defineEmits(['hide-editor'])

const props = defineProps({
    hideButton: {type: Boolean, default: false},
    isCustomer: {type: Boolean, default: true}
})

const show = (_subAccount: SubAccount | NewSubAccount, _fulfillment?: Fulfillment) => {
    subAccount.value = _subAccount
    fulfillment.value = _fulfillment
    visible.value = true
}

const hide = () => {
    visible.value = false
}

emit('hide-editor', hide)

const showCreateNew = () => {
    if (props.isCustomer)
        show(defaultNewCustomer())
    else
        show(defaultNewSupplier())
}

onEvent(SET_SUB_ACCOUNT_EDITOR_CONTENT, (payload) => {
    const {content, panelId, fulfillment} = payload as SetSubAccountEditorContent
    if (panelId !== currentPanelId?.value) return
    show(content, fulfillment)
})

onUnmounted(cleanUp)

const refreshAndHide = () => {
    if (subAccount.value?.relationType === CUSTOMER) {
        fetchCustomers()
    } else {
        fetchSuppliers()
    }
    hide()
}

defineExpose({show})

</script>

<style>

</style>